import {PulseLoader} from "react-spinners";
import React from "react";

export const FetchLoading = () => {
  return <><div className="mt-5 flex align-middle text-primary"><span className="mr-5">Načítávám</span> <div className="items-center"><PulseLoader size={10} color={"#007BB3"}/></div></div></>
}
